import { shareEntityButtonStyles } from "@insite/content-library/Components/ShareEntityButton";
import { headerStyles } from "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailHeader";
import { searchFieldWrapperStyles } from "@insite/content-library/Widgets/OrderHistory/SearchFieldWrapper";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

shareEntityButtonStyles.button = {
    css: css`
        &:disabled {
            background: ${getColor("primary.contrast")} !important;
            span[class^="TypographyStyle"] {
                color: ${getColor("text.main")};
                font-size: 14px;
                line-height: ${TYPOGRAPHY.lineHeight.base};
            }
            /* opacity: 0.5; */
        }
        border-radius: 0px;
        padding: 10px 34px;
        background: ${getColor("common.background")};
        border: 2px solid ${getColor("primary")} !important;

        span[class^="TypographyStyle"] {
            color: ${getColor("text.main")};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        }
        &:hover {
            /* background: ${getColor("text.accent")}; */
            /* border: 2px solid  background: ${getColor("text.accent")}; */
            opacity: 0.3;
            background: none !important;

            /* span[class^="TypographyStyle"] {
                color: ${getColor("secondary")};
           
        } */
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    padding: 10px 34px;
                `,
                null,
                null,
                null,
                null,
            ])}
    `,
};
shareEntityButtonStyles.cancelButton = {
    variant: "secondary",
    css: css`
        border-radius: 0px;
        padding: 10px 34px;
        background: ${getColor("common.background")};
        border: 2px solid ${getColor("primary")} !important;

        span[class^="TypographyStyle"] {
            color: ${getColor("text.main")};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        }
        &:hover {
            /* background: ${getColor("text.accent")}; */
            /* border: 2px solid  background: ${getColor("text.accent")}; */
            opacity: 0.3;
            background: none !important;

            /* span[class^="TypographyStyle"] {
                color: ${getColor("secondary")};
           
        } */
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    padding: 10px 34px;
                `,
                null,
                null,
                null,
                null,
            ])}
    `,
};
shareEntityButtonStyles.sendButton = {
    css: css`
        margin-left: 10px;
        border-radius: 0;
        padding: 10px 34px;
        background: ${getColor("primary")};
        border: 2px solid ${getColor("primary")};
        span[class^="TypographyStyle"] {
            color: ${getColor("secondary")};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        }
        &:hover {
            background: ${getColor("text.accent")};
            border: 2px solid ${getColor("text.accent")};
            span[class^="TypographyStyle"] {
                color: ${getColor("primary.contrast")};
            }
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                css`
                    padding: 10px 34px;
                `,
                null,
                null,
            ])}
    `,
};
headerStyles.printButton = {
    css: css`
        border-radius: 0;
        padding: 10px 34px;
        background: ${getColor("primary")};
        border: 2px solid ${getColor("primary")};
        span[class^="TypographyStyle"] {
            color: ${getColor("primary.contrast")};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        }
        &:hover {
            background: ${getColor("text.accent")};
            /* border: 2px solid  background: ${getColor("text.accent")}; */
            span[class^="TypographyStyle"] {
                color: ${getColor("secondary")};
            }
        }
    `,
};
